import { AccountUtils } from '@shared/commons/cache/AccountUtils';
import React from 'react';
import { InstrumentTypeLogo } from '../../elements/InstrumentTypeLogo';
export class AccountContextMenuItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.onClick = () => {
            const item = this.props.item;
            if (!isNullOrUndefined(item.event)) {
                if (this.props.item.canCheck) {
                    item.checked = !item.checked;
                    this.forceUpdate();
                }
                item.event(item);
            }
            if (!this.props.item.canCheck) {
                this.props.onCloseContextMenu();
            }
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        const account = this.props.item.value;
        const maxAccountModeWidth = this.props.accountModeWidth;
        return (React.createElement("div", { key: account.userPin, className: `new-context-menu-row${activeStyle}${disabledStyle}`, ref: this.ref, onClick: this.onClick },
            React.createElement("div", { className: "new-context-menu-item small-gap" },
                this.renderCheckedIcon(),
                React.createElement("div", { className: "new-context-menu-item-account-mode", style: {
                        width: maxAccountModeWidth,
                        minWidth: maxAccountModeWidth,
                        maxWidth: maxAccountModeWidth
                    } },
                    React.createElement("div", { className: `accountWidget-headerButton-${AccountUtils.GetAccountModeStyle(account)}` }, AccountUtils.GetAccountModeText(account))),
                this.renderInstrumentType(),
                React.createElement("div", { className: "new-context-menu-item-text-container" },
                    React.createElement("div", { className: "new-context-menu-item-text-container-text" }, account.toString(true))))));
    }
    renderCheckedIcon() {
        if (!this.props.item.canCheck) {
            return null;
        }
        const icon = this.props.item.checked ? (React.createElement("svg", null,
            React.createElement("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#accept" }))) : null;
        return React.createElement("div", { className: "new-context-menu-item-icon" }, icon);
    }
    renderInstrumentType() {
        if (!this.props.isVisibleInstrumentType) {
            return null;
        }
        const account = this.props.item.value;
        const accountInstrumentStyle = {};
        if (!AccountUtils.needAddType(account)) {
            accountInstrumentStyle.visibility = 'hidden';
        }
        return (React.createElement("div", { className: "new-context-menu-item-account-instrument", style: accountInstrumentStyle },
            React.createElement(InstrumentTypeLogo, { instrumentType: account.PreferredInstrumentType })));
    }
}
